{
  "citLinkSettingsDialog": {
    "title": "Настройки",
    "testing": "Тестирование",
    "delete": "Удалить парсер",
    "type": "Тип",
    "parameters": "Параметры",
    "filter": "Фильтр",
    "ciTypeAttributes": "Атрибуты ТКЕ",
    "fetcher": {
      "type": "Тип"
    },
    "parser": {
      "type": "Тип"
    },
    "scope": "Сфера действия",
    "additionalAttributes": {
      "label": "Доп. атрибуты",
      "name": "Название",
      "value": "Значение"
    },
    "unsavedChanges": {
      "title": "Внимание!",
      "message": "Есть несохраненные изменения!",
      "cancel": "Вернуться к редактированию",
      "ok": "Отменить изменения"
    },
    "tabs": {
      "parser": "Парсер",
      "fetcher": "Фетчер",
      "filter": "Фильтр",
      "linkAttributes": "Атрибуты связи"
    }
  },
  "citAttributeSettingsDialog": {
    "title": "Настройки",
    "testing": "Тестирование",
    "delete": "Удалить парсер",
    "type": "Тип",
    "parameters": "Параметры",
    "filter": "Фильтр",
    "fetcher": {
      "type": "Тип"
    },
    "parser": {
      "type": "Тип"
    },
    "unsavedChanges": {
      "title": "Внимание!",
      "message": "Есть несохраненные изменения!",
      "cancel": "Вернуться к редактированию",
      "ok": "Отменить изменения"
    },
    "tabs": {
      "parser": "Парсер",
      "fetcher": "Фетчер",
      "modifiers": "Модификаторы"
    }
  },
  "linkAttributesTab": {
    "settings": "Настройки"
  },
  "linkAttributeSettingsDialog": {
    "title": "Настройки",
    "tabs": {
      "parser": "Парсер"
    }
  },
  "testingDialog": {
    "title": "Тестирование парсера",
    "tabs": {
      "ci": "CI",
      "manually": "Вручную"
    },
    "searchCi": "Поиск CI",
    "runTest": "Запустить тест",
    "runResult": "Результаты выполнения",
    "config": "Конфигурация",
    "error": {
      "ciNotSelected": "Не выбран CI"
    }
  },
  "citPage": {
    "list": {
      "title": "Список CIT",
      "empty": "Список CIT пуст",
      "count": {
        "active": "Активные CI",
        "deleted": "Удалённые CI",
        "ownType": "Своего типа",
        "childTypes": "Дочерних типов"
      }
    },
    "item": {
      "empty": "Выберите CIT или создайте новый",
      "newItem": "Новый ТКЕ"
    },
    "export": {
      "title": "Настройки экспорта",
      "exclude_extend": "Ссылка на родительский ТКЕ",
      "exclude_ext_link": "Связи",
      "reset_ext_like_parent": "Родительские настройки"
    },
    "import": {
      "title": "Перенесите файл сюда или нажмите",
      "message": "Прикрепляйте по одному файлу"
    },
    "select": {
      "title": "Выбор",
      "dependants": "Выбор зависимых элементов",
      "inherited": "Выбор родительских элементов",
      "children": "Выбор дочерних элементов",
      "links": "Выбор связей",
      "selectRecursively": "Выбрать рекурсивно",
      "deselectRecursively": "Снять выбор рекурсивно"
    },
    "likeParent": "Разрешить переопределение"
  },
  "citItem": {
    "title": "Тип конфигурационной единицы",
    "tab": {
      "cit": "ТКЕ",
      "attributes": "Атрибуты",
      "links": "Доступные связи",
      "createCI": "Список КЕ",
      "healthIndicators": "Индикаторы здоровья",
      "metrics": "Метрики",
      "variables": "Переменные",
      "scripts": "Скрипты",
      "actions": "Действия",
      "naming": "Именование",
      "identification": "Идентификация",
      "events": "События",
      "deletePolicy": "Хранение"
    },
    "deleteDialog": {
      "title": "Найдены CI в удаляемых CIT",
      "messageTemplate": "Для CIT \"{{type}}\" в количестве CI \"{{count}}\""
    },
    "linksGraph": {
      "title": "Карта ТКЕ",
      "summary": {
        "outgoing": "Исходящие связи",
        "inherited": "из них унаследованы",
        "incoming": "Входящие связи"
      },
      "ancestors": "Путь до корня",
      "inherited": "Унаследованные связи",
      "descendants": "Наследники",
      "fit": "Вписать граф",
      "png": "Сохранить PNG",
      "collapse": "Свернуть граф",
      "expand": "Развернуть граф",
      "openLinks": "Доступные связи",
      "empty": "У типа нет связей. Добавить связь можно на вкладке «Доступные связи»",
      "node": {
        "count": "КЕ {{value}}",
        "total": "с наследниками {{value}}",
        "deleted": "удал. {{value}}",
        "inheritors_one": "+{{count}} наследник",
        "inheritors_few": "+{{count}} наследника",
        "inheritors_many": "+{{count}} наследников"
      },
      "tooltip": {
        "links": "Связей КЕ: {{value}}",
        "deleted": "Помечены к удалению: {{value}}",
        "inheritedFrom": "Унаследована от «{{ciType}}»",
        "sources": "Источник и наследники",
        "inheritance": "Наследование"
      },
      "legend": {
        "inheritance": "Наследование",
        "inherited": "Унаследованная связь"
      }
    }
  },
  "citTab": {
    "name": "Название",
    "label": "Отображение",
    "parent": "Родительский ТКЕ",
    "icon": "Иконка",
    "iconSize": {
      "label": "Размер иконки",
      "default": "Средний",
      "small": "Маленький",
      "large": "Большой"
    },
    "color": "Цвет",
    "changeReq": "Редактирование через запрос на изменение",
    "fetchConfig": "Конфигурация извлечения",
    "scriptExecutor": "Исполнитель сценария"
  },
  "attributesTab": {
    "parser": "Парсер",
    "attribute": "Атрибут",
    "modifiers": {
      "editable": "Редактируемый",
      "hidden": "Скрытый",
      "required": "Обязательный",
      "save_history": "Сохряет историю"
    },
    "sections": {
      "modifiers": "Модификаторы",
      "parser": "Парсер",
      "fetcher": "Фетчер",
      "attributes": "Атрибуты"
    },
    "cols": {
      "name": "Название",
      "modifiers": "Модификаторы"
    },
    "checkParserTooltip": "Проверить парсер",
    "getParserDescription": "Получить полное описание",
    "addDataToCheckValidity": "Введите данные для проверки",
    "result": "Результат"
  },
  "linksTab": {
    "linkType": "Тип связи",
    "count": "Активные",
    "del_count": "Удаленные",
    "numberOfLinks": "Количество связей",
    "citType": "Тип конфигурационной единицы",
    "settings": "Настройки",
    "linkList": "Список связей",
    "link": "Связь",
    "parser": "Парсер",
    "attribute": "Атрибут",
    "modifiers": {
      "editable": "Редактируемый",
      "hidden": "Скрытый",
      "required": "Обязательный",
      "save_history": "Сохряет историю"
    },
    "filter": {
      "validation": {
        "duplicatedName": "Дублирующееся имя",
        "unconfiguredParser": "Не настроен парсер"
      }
    },
    "sections": {
      "modifiers": "Модификаторы",
      "parser": "Парсер",
      "fetcher": "Фетчер",
      "filter": "Фильтр",
      "attributes": "Атрибуты"
    },
    "cols": {
      "attributes": "Атрибуты",
      "modifiers": "Модификаторы"
    },
    "checkParserTooltip": "Проверить парсер",
    "addDataToCheckValidity": "Введите данные для проверки",
    "result": "Результат"
  },
  "attributeSelectDialog": {
    "title": "Добавить атрибут",
    "empty": "Список атрибутов пуст"
  },
  "variablesTab": {
    "table": {
      "name": "Название",
      "type": "Тип",
      "description": "Описание"
    }
  },
  "variableDialog": {
    "title": "Переменная",
    "name": "Название",
    "type": "Тип",
    "description": "Описание"
  },
  "scriptsTab": {
    "types": {
      "ci": "КЕ",
      "attribute": "Атрибуты",
      "connection": "Связи",
      "others": "Остальные"
    },
    "items": {
      "type": "Тип",
      "name": "Название",
      "managed_attribute": "Редактируемый аттрибут",
      "dst_type_id": "Назначение",
      "link_id": "Тип связи",
      "description": "Описание",
      "action": "Действие",
      "script": "Скрипт",
      "isRollback": "Отдельный скрипт отката",
      "scriptRollback": "Скрипт отката"
    },
    "segments": {
      "script": "скрипт",
      "code": "код",
      "noRollback": "без отката"
    },
    "scriptDialog": {
      "title": "Скрипт",
      "add": "создать",
      "update": "изменить",
      "resultAttribute": "Атрибут в который сохранится результат выполнения скрипта"
    }
  },
  "actionsTab": {
    "name": "Название класса"
  },
  "actionDialog": {
    "title": "Действие",
    "name": "Класс",
    "settings": "Настройки"
  },
  "namingTab": {
    "template": "Шаблон",
    "updNames": "Обновить имена КЕ",
    "hint": {
      "title": "Пример шаблона"
    }
  },
  "identificationTab": {
    "or": "ИЛИ",
    "and": "И",
    "addAttributes": "Добавить атрибуты",
    "legend": "Правила идентификации"
  },
  "eventDialog": {
    "title": "Событие",
    "script": "Скрипт",
    "event": "Событие"
  },
  "metricsTab": {
    "dialogTitle": "Настройка метрики",
    "connectMetric": "Привязать метрику к CI",
    "disconnectMetric": "Отвязать метрику от CI",
    "items": {
      "name": "Название",
      "nameValidation": "Название должно содержать только маленькие латинские буквы, цифры или символ \"_\"",
      "job": "Задания",
      "description": "Описание",
      "module": "Модуль",
      "target": "Шаблон формирования цели",
      "filter": "Фильтр",
      "forceDeleteWarning": "Удаление метрики затронет следующие индикаторы здоровья",
      "targetsCount": "Кол-во таргетов",
      "failedTargetsCount": "Ошибки формирования"
    }
  },
  "hiTab": {
    "dialogTitle": "Индикатор здоровья",
    "dialogSelectDescription": "Выберите узел TQL, на экземплярах которого будут созданы индикаторы здоровья.",
    "nodeIdHint": "Настройка выполняется относительно узла TQL шаблона. У каждого узла есть номер (ID) — по нему узел адресуется в правилах и шаблонах.",
    "nodeReferenceHint": "Выбранный узел адресуется в правилах и шаблонах как {{reference}}.",
    "connectHi": "Привязать индикатор к CI",
    "disconnectHi": "Отвязать индикатор от CI",
    "addHIDepends": "Добавить связанный индикатор",
    "items": {
      "name": "Название индикатора здоровья",
      "metric": "Метрика",
      "relativeMetric": "Связанная метрика",
      "hi": "Индикатор здоровья",
      "hiDescription": "Выберите ИЗ, значения которых будут влиять на расчетный индикатор.",
      "hit": "Тип индикатора здоровья",
      "hiSource": "Источник индикатора здоровья",
      "hiSetting": "Настройка индикатора здоровья",
      "type": "Тип",
      "source": "Источник значений индикатора здоровья",
      "rule": "Правило",
      "expression": "Выражение",
      "percentile": "Перцентиль",
      "useFilter": "Использовать фильтр",
      "filter": "Фильтр",
      "filterDescription": "Выбранный ИЗ может использоваться в нескольких шаблонах мониторинга. Вы можете ограничить источник значений расчетного ИЗ, выбрав конкретные шаблоны мониторинга. Пустое поле 'Фильтра' означает, что источником значений расчетного ИЗ будут все КЕ выбранного узла TQL, на которых настроен указанный ИЗ.",
      "tabsDescription": "Источником значений для расчетного индикатора здоровья являются другие индикаторы, определённые на смежных КЕ. Выберите узел TQL для определения смежных КЕ.",
      "exporter": "Экспортер",
      "defaultStatus": "Статус по умолчанию",
      "undefinedLabel": "узел не определен",
      "removedNodeLabel": "узел удалён из TQL",
      "noMetriclabel": "связанная метрика удалена",
      "addMore": "Добавить еще",
      "chooseSource": "Выберите источник",
      "chooseSourceTitle": "Выберите источник индикатора здоровья",
      "subscriptions": "Подписки",
      "hisCount": "Кол-во ИЗ",
      "failedHintsCount": "Ошибки формирования",
      "templateLabel": "Узлы TQL шаблона мониторинга",
      "alertRuleLabel": "Правило формирования алертинга",
      "alertRuleConfigLabel": "Конфигурация правила алертинга",
      "ciHintRule": "Правило формирования ci_hint",
      "hiHint": "hi_hint",
      "ruleAgent": "Агент обработки правил",
      "status": "Статус",
      "tqlEdge": "Узел TQL",
      "tqlEdgePlaceholder": "Название или номер узла",
      "sourceNode": "Узел TQL — источник",
      "sourceNodeDescription": "Узлы, уже добавленные как источники, и узел самого индикатора в списке не показываются."
    },
    "media": {
      "title": "Источник медиаданных",
      "connector": "Подключение",
      "connectorDescription": "Выберите S3-подключение.",
      "ruleType": "Способ задания пути",
      "string": "Строка",
      "attribute": "Атрибут",
      "resourcePath": "Путь к ресурсу",
      "attributeName": "Имя атрибута КЕ",
      "attributeDescription": "Путь берётся из значения атрибута КЕ один раз и сохраняется в индикаторе",
      "timePrefix": "Раскладка по времени",
      "timePrefixDescription": "Разрешается при запросе, из окна интервала",
      "fileName": "Время в имени файла",
      "margin": "Допуск окна",
      "timezone": "Часовой пояс",
      "timezoneDescription": "Смещение от UTC от −12:00 до +14:00 в формате ±HH:MM. Минуты: 00, 30 или 45.",
      "secondsSuffix": " с",
      "validation": "Заполните подключение, путь к ресурсу, раскладку по времени и имя файла. Допуск — целое число от 0 до 3600 секунд. Укажите часовой пояс в формате ±HH:MM с минутами 00, 30 или 45, от −12:00 до +14:00."
    },
    "subscriptionDialogTitle": "Подписки ИЗ",
    "subscriptionFields": {
      "severity": "Выберите типы тревог"
    },
    "severityMapping": {
      "title": "Изменение критичности",
      "description": "Настройте правила изменения критичности для расчетного ИЗ",
      "empty": "Правила не настроены",
      "rule": "Правило {{number}}",
      "source": "Если значение равно",
      "target": "Установить критичность",
      "delete": "Удалить правило",
      "validation": "Проверьте правила изменения критичности"
    },
    "notSet": "Не задан",
    "deleteDialog": {
      "message": "Удаляем привязку индикатора здоровья <strong>\"{{hiTypeLabel}}\"</strong>. Продолжить?",
      "forceCheckbox": "Удалить <strong>выключенные</strong> привязки в расчетных ИЗ",
      "disabledHint": "Удалить можно только выключенную привязку. Выключите её переключателем в колонке «Статус»."
    },
    "propagation": {
      "title": "Передача статуса",
      "source": "Источник",
      "receiver": "Получатель",
      "receiverNode": "Узел TQL — получатель",
      "edge": "Связь TQL",
      "choose": "Выберите связь",
      "chooseDescription": "Между выбранными узлами несколько связей. Укажите связь для этого правила.",
      "automatic": "Выбрана автоматически",
      "along_link": "По направлению связи TQL",
      "against_link": "Против направления связи TQL",
      "pending": "Направление появится после выбора связи.",
      "ambiguous": "Выберите одну из подходящих связей TQL.",
      "missing": "В TQL нет подходящей прямой связи между выбранными узлами.",
      "stale": "Сохранённая связь больше не подходит или удалена из TQL. Выберите другую связь.",
      "linkSettings": "Настройка связи в ТКЕ",
      "showTql": "Показать в TQL",
      "limits": "Ограничения: {{source}} → {{target}}",
      "variant": "Вариант {{number}}"
    }
  },
  "attributesPage": {
    "title": "Атрибуты",
    "table": {
      "name": "Системное имя",
      "label": "Название",
      "key": "Ключ",
      "type": "Тип",
      "systemFunction": "Целевое использование",
      "tags": "Теги"
    }
  },
  "attributeDialog": {
    "title": "Атрибут",
    "valueSchemaEditor": {
      "editor": {
        "title": "Редактор",
        "schema": "Схема",
        "uiSchema": "UI Схема"
      },
      "preview": {
        "title": "Предпросмотр"
      },
      "template": {
        "title": "Шаблон",
        "saveTemplate": "Сохранить как шаблон",
        "group": "Группа",
        "name": "Название"
      }
    },
    "form": {
      "systemFunctionWarning": "Этот атрибут используется системой и не может быть изменен.",
      "name": "Название",
      "label": "Отображение",
      "key": "Ключ",
      "type": "Тип",
      "preview": "Предпросмотр",
      "systemFunction": "Целевое использование",
      "valueSchema": "Схема значения",
      "uiEditor": "Редактор",
      "requiredField": "Обязательное поле",
      "emptyType": "Выберите тип",
      "invalidKey": "Ключ может содержать только строчные латинские символы, цифры или символ подчеркивания",
      "modifiers": {
        "label": "Модификаторы",
        "blocked": "Заблокировать самостоятельное редактирование",
        "required": "Обязательный"
      },
      "schemaPresets": {
        "default": {
          "label": "По умолчанию"
        },
        "string": {
          "label": "Строка"
        },
        "number": {
          "label": "Число"
        },
        "string_list": {
          "label": "Список строк"
        },
        "date-time": {
          "label": "Дата и время"
        },
        "textarea": {
          "label": "Текст"
        },
        "float": {
          "label": "Число с плавающей точкой",
          "minimum": "Минимум",
          "maximum": "Максимум"
        },
        "integer": {
          "label": "Целое число",
          "minimum": "Минимум",
          "maximum": "Максимум"
        },
        "slider": {
          "label": "Слайдер",
          "minimum": "Минимум",
          "maximum": "Максимум",
          "step": "Шаг"
        },
        "updown": {
          "label": "Стрелки",
          "minimum": "Минимум",
          "maximum": "Максимум",
          "step": "Шаг"
        },
        "codeEditor": {
          "label": "Редактор кода"
        },
        "color": {
          "label": "Цвет"
        },
        "json": {
          "label": "JSONB"
        },
        "form": {
          "label": "Форма"
        },
        "array": {
          "label": "Массив",
          "itemSchema": "Схема элемента",
          "uiItemSchema": "UI схема элемента",
          "withModal": "Модальное окно",
          "typeError": "Свойство 'type' должоно быть 'object'",
          "propertiesError": "Свойство 'properties' не должно быть пустым"
        },
        "schema": {
          "label": "Схема"
        },
        "file": {
          "label": "Файл"
        },
        "password": {
          "label": "Пароль"
        },
        "ip": {
          "label": "IP адрес/сети"
        },
        "boolean": {
          "label": "Логический"
        },
        "radio": {
          "label": "Радио",
          "true": "Положительное название",
          "false": "Отрицательное название"
        }
      },
      "uiTypes": {
        "textarea": "Текстовая область",
        "editor": "Редактор кода",
        "schema": "Изменить схему атрибута"
      }
    }
  },
  "healthIndicatorsPage": {
    "title": "Индикаторы здоровья",
    "table": {
      "name": "Системное имя",
      "label": "Название",
      "tags": "Теги",
      "template": "Шаблон",
      "templateList": "Список шаблонов",
      "description": "Описание",
      "filter": "Фильтр"
    },
    "template": {
      "true": "Есть",
      "false": "-",
      "empty": "Отсутствует"
    },
    "deleteDialog": {
      "message": "Удаляем индикатор здоровья <strong>\"{{hiTypeLabel}}\"</strong>. Продолжить?",
      "forceCheckbox": "Удалить <strong>выключенные</strong> индикаторы здоровья в шаблонах мониторинга"
    }
  },
  "healthIndicatorDialog": {
    "title": "Индикатор здоровья",
    "form": {
      "name": "Название",
      "label": "Отображение",
      "config": "Шаблон",
      "description": "Описание",
      "severity": "Поле критичности события лога",
      "hiOptions": "Параметры индикатора здоровья",
      "parser": "Парcер критичности лога"
    }
  },
  "userPage": {
    "title": "Дополнительные поля пользователя",
    "info": "В дополнение к стандартным полям (фамилия, имя, отчество, логин, аватар), для пользователя будут доступны следующие поля:",
    "form": {
      "title": "Название",
      "type": "Тип"
    }
  },
  "userCustomFieldDialog": {
    "title": "Дополнительное поле пользователя",
    "label": "Название",
    "name": "Ключ",
    "type": "Тип"
  },
  "ldapPage": {
    "form": {
      "createTitle": "Новое LDAP-подключение",
      "sections": {
        "basicInfo": "Основная информация",
        "serverCredentials": "Реквизиты сервера",
        "searchScopes": "Области поиска",
        "additionalSettings": "Дополнительные настройки",
        "attributeMapping": "Сопоставление атрибутов"
      },
      "displayName": {
        "label": "Отображаемое имя",
        "description": "Имя, которое будет отображаться пользователям на странице входа",
        "placeholder": "Мой LDAP"
      },
      "name": {
        "label": "Название",
        "description": "Уникальный идентификатор подключения. Используется внутри системы. После сохранения изменить нельзя.",
        "placeholder": "my_ldap"
      },
      "host": {
        "label": "Хост"
      },
      "port": {
        "label": "Порт"
      },
      "protocol": {
        "label": "Протокол",
        "placeholder": "Без шифрования"
      },
      "verifySsl": {
        "label": "Проверять SSL‑сертификат",
        "description": "Отключение проверки сертификата допустимо только в тестовой среде. Не рекомендуется для production‑окружения."
      },
      "anonymous": {
        "label": "Анонимное подключение"
      },
      "baseDn": {
        "label": "Base DN"
      },
      "userDns": {
        "label": "User DNs",
        "itemLabel": "User DN"
      },
      "groupDns": {
        "label": "Group DNs",
        "itemLabel": "Group DN"
      },
      "userTemplate": {
        "label": "Шаблон поиска пользователей",
        "description": "Например: (sAMAccountName={login})."
      },
      "groupTemplate": {
        "label": "Шаблон поиска групп"
      },
      "active": {
        "label": "Активировать подключение",
        "description": "При включении данное подключение может использоваться системой для поиска и аутентификации пользователей."
      },
      "loginExpression": {
        "label": "JQ‑выражение для логина",
        "placeholder": ".data[0].attributes.sAMAccountName[0]",
        "description": "JQ‑выражение, применяемое к объекту с ключами data (найденные записи каталога, значения атрибутов в них — массивы строк) и groups (группы пользователя). Результат будет сохранён в поле login и использован для сопоставления пользователя с существующими учётными записями."
      }
    },
    "test": {
      "button": "Протестировать соединение",
      "credentialsTitle": "Учетные данные для теста",
      "error": "Ошибка",
      "loading": "Выполняется проверка соединения…",
      "successTitle": "Тест соединения успешен",
      "failureTitle": "Тест соединения неуспешен",
      "saveFirst": "Сначала сохраните подключение",
      "credentialsRequired": "Для теста соединения заполните логин и пароль",
      "popupBlocked": "Окно заблокировано",
      "popupBlockedMessage": "Разрешите всплывающие окна для этого сайта или тест откроется в текущей вкладке.",
      "backToSettings": "Вернуться к настройкам",
      "closeWindow": "Закрыть окно",
      "noKey": "Не найден ключ теста",
      "noPayload": "Не найдены данные для теста (обновите страницу и попробуйте снова)",
      "unknownError": "Неизвестная ошибка",
      "errorDetails": "Детали",
      "mappedUser": "Сопоставленный пользователь",
      "rawData": "Исходные данные",
      "fullResult": "Полный результат",
      "success": "Соединение установлено",
      "failed": "Не удалось установить соединение"
    },
    "attributeMapping": {
      "addButton": "Добавить",
      "editRule": "Редактировать правило",
      "table": {
        "name": "Название",
        "expression": "Выражение",
        "syncType": "Тип синхронизации"
      },
      "syncType": {
        "DISABLE": "Синхронизация выключена",
        "PERIODIC": "Обновлять периодически",
        "ON_CREATE": "Только при создании пользователя",
        "IF_EXIST": "Обновлять только если значение пришло от IdP"
      },
      "validation": {
        "nameRequired": "Заполните название атрибута",
        "syncTypeRequired": "Выберите тип синхронизации",
        "expressionRequired": "Заполните выражение"
      },
      "addModal": {
        "title": "Добавить атрибуты",
        "searchPlaceholder": "Поиск",
        "selectAll": "Выбрать все",
        "noAttributes": "Нет данных",
        "apply": "Применить"
      },
      "editModal": {
        "title": "Настройка атрибута: {{attribute}}",
        "description": "Выражение для получения значения атрибута из записи пользователя LDAP (формат аналогичен JQ/используемому движку).",
        "syncTypeLabel": "Тип синхронизации",
        "syncTypeDescription": "Определяет, когда и как обновлять значение атрибута из LDAP."
      }
    },
    "syncTab": {
      "title": "Атрибуты синхронизации",
      "addTitle": "Добавить конфигурацию",
      "columns": {
        "attribute": "Атрибут",
        "syncType": "Тип синхронизации",
        "status": {
          "label": "Статус",
          "active": "Активен",
          "inactive": "Не активен"
        },
        "type": {
          "label": "Тип",
          "base": "Основной",
          "optional": "Дополнительный"
        }
      },
      "form": {
        "name": {
          "label": "Атрибут пользователя",
          "description": "Атрибут пользователя, значение которого будет заполнено при синхронизации с сервером LDAP"
        },
        "active": {
          "label": "Включить синхронизицию",
          "description": "Если синхронизация включена, то значение атрибута будет заполнено при синхронизации с сервером LDAP",
          "error": "Синхронизация не может быть включена с пустым значением Выражение"
        },
        "type": {
          "label": "Тип синнхронизации",
          "description": "Пользователь  - атрибут получит значение указанного LDAP атрибута пользователя. Группа - будет осуществлен поиск группы по регулярному выражению",
          "user": "Пользователь",
          "group": "Группа"
        },
        "user": {
          "expression": {
            "label": "Выражение",
            "description": "Запрос LDAP для поиска значения атрибута"
          }
        },
        "group": {
          "expression": {
            "label": "Выражение",
            "description": "Регулярное выражение для поиска группы в которой состоит пользователь"
          },
          "true_action": {
            "label": "Способ заполнения значения атрибута пользователя",
            "description": "LITERAL - в атрибут пользователя будет записано значение из поля \"Значение\", REGEX - в атрибут будет записан результат регулярного выражения, выполненого по найденной группе",
            "value": {
              "literal": "Значение, которое будет записано в атрибут пользователя",
              "regex": "Регулярное выражение, для выбора значения из группы польльзователя"
            }
          },
          "false_action": {
            "label": "Значение поля в случае отсутствия группы в списке групп пользователя",
            "description": "Поле принимает указанное значение в случае отсутствия искомой группы у пользователя"
          }
        }
      }
    },
    "list": {
      "title": "Список LDAP",
      "empty": "Список LDAP пуст",
      "newElement": "Новый LDAP"
    },
    "tabs": {
      "connection": "Соединение",
      "sync": "Синхронизация"
    },
    "item": {
      "empty": "Выберите LDAP или создайте новый",
      "title": "Конфигурация LDAP"
    },
    "connectionTab": {
      "form": {
        "useConnection": "Использовать подключение для поиска пользователей",
        "checkConnection": "Проверить соединение",
        "connectionSuccessMsg": "Соединение установлено",
        "title": "Название",
        "active": "Активно",
        "inactive": "Не активно",
        "host": "Хост",
        "port": "Порт",
        "anonymous_connection": "Анонимное подключение",
        "ignore_cert": "Принимать непроверенные сертификаты",
        "no_encryption": "Без шифрования",
        "protocol": "Протокол",
        "baseDn": "BaseDN",
        "surname": "Фамилия",
        "name": "Имя",
        "patronymic": "Отчество",
        "login": "Логин",
        "email": "Email",
        "avatar": "Аватар",
        "status": "Статус",
        "userCredentials": "Пользователь, от лица которого будет осуществляться поиск по LDAP серверу",
        "userSearchTemplate": "Шаблон поиска пользователя",
        "groupSearchTemplate": "Шаблон поиска группы",
        "userSearchScopes": "Области поиска пользователя",
        "serverDetails": "Реквизиты сервера"
      }
    },
    "select": {
      "user": "Пользователь",
      "belongs": "Принадлежит группе",
      "memberOf": "Существует группа"
    },
    "table": {
      "system": "Система",
      "ldap": "LDAP",
      "type": "Тип",
      "surname": "Фамилия"
    }
  },
  "prometheusPage": {
    "title": "Prometheus",
    "reloadButton": "Перезапустить Prometheus",
    "controlModeLabel": "Способ управления конфигурацией",
    "tabs": {
      "prometheus": "Prometheus",
      "alertManager": "Менеджер оповещений",
      "alerts": "Правила оповещений",
      "targets": "Цели",
      "exporters": "Экспортеры"
    },
    "labels": {
      "alerts": "Конфигурация тревог",
      "targets": "Конфигурация целей",
      "exporters": "Конфигурация экспортеров"
    }
  },
  "oidcPage": {
    "list": {
      "title": "Список OIDC провайдеров",
      "empty": "Список OIDC провайдеров пуст",
      "newElement": "Новый OIDC провайдер"
    },
    "form": {
      "createTitle": "Создание нового OIDC-подключения",
      "editTitle": "Редактирование подключения: {{name}}",
      "sections": {
        "basicInfo": "Основная информация",
        "credentials": "Учетные данные",
        "endpoints": "Конфигурация подключений",
        "endpointsAdvanced": "Расширенные настройки",
        "additionalSettings": "Дополнительные настройки",
        "attributeMapping": "Сопоставление атрибутов"
      },
      "displayName": {
        "label": "Отображаемое имя",
        "description": "Имя, которое будет отображаться пользователям на странице входа",
        "placeholder": "Google"
      },
      "name": {
        "label": "Название",
        "description": "Уникальный идентификатор подключения. Используется внутри системы. После сохранения изменить нельзя.",
        "placeholder": "google"
      },
      "nameValidation": "Допустимые символы: строчные латинские буквы, цифры и подчеркивание. Должно начинаться с буквы.",
      "authorizeUrl": {
        "label": "URL авторизации (Auth URL)",
        "description": "URL эндпоинта авторизации OIDC-провайдера",
        "placeholder": "https://accounts.google.com/o/oauth2/v2/auth"
      },
      "accessTokenUrl": {
        "label": "URL токена (Token URL)",
        "description": "URL эндпоинта получения токена доступа",
        "placeholder": "https://oauth2.googleapis.com/token"
      },
      "userinfoEndpoint": {
        "label": "URL профиля (UserInfo)",
        "description": "URL эндпоинта получения информации о пользователе",
        "placeholder": "https://openidconnect.googleapis.com/v1/userinfo"
      },
      "serverMetadataUrl": {
        "label": "Discovery URL (.well-known)",
        "description": "URL для получения метаданных OIDC-провайдера (discovery endpoint)",
        "placeholder": "https://accounts.google.com/.well-known/openid-configuration"
      },
      "tokenEndpointAuthMethod": {
        "label": "Метод аутентификации",
        "description": "Метод аутентификации при запросе токена",
        "placeholder": "Выберите метод...",
        "options": {
          "client_secret_basic": "Basic Auth",
          "client_secret_post": "POST Body",
          "client_secret_jwt": "JWT",
          "private_key_jwt": "Private Key",
          "none": "Public client"
        }
      },
      "clientId": {
        "label": "Client ID",
        "description": "Идентификатор клиента, полученный при регистрации приложения у OIDC-провайдера",
        "placeholder": "Введите ID клиента"
      },
      "clientSecret": {
        "label": "Client Secret",
        "description": "Секрет клиента, полученный от OIDC-провайдера",
        "placeholderEdit": "Оставьте пустым, чтобы не менять"
      },
      "scope": {
        "label": "Scopes",
        "description": "Запрашиваемые области (scopes), разделенные пробелом. openid является обязательным."
      },
      "verifySsl": {
        "label": "Проверять SSL-сертификат",
        "description": "Отключите, только если вы используете самоподписанные сертификаты в тестовой среде. Не рекомендуется для production-окружения."
      },
      "active": {
        "label": "Активировать подключение",
        "description": "Делает данный способ входа доступным для пользователей на странице логина"
      },
      "toggleAdvancedEndpoints": "Расширенные настройки",
      "showAdvancedEndpoints": "Показать расширенные настройки",
      "hideAdvancedEndpoints": "Скрыть расширенные настройки",
      "loginExpression": {
        "label": "Правило получения логина из UserInfo",
        "description": "JQ‑выражение, применяемое к OIDC UserInfo. Результат будет сохранён в поле login и использован для сопоставления пользователя с существующими учётными записями (по умолчанию .email).",
        "placeholder": ".email"
      }
    },
    "attributeMapping": {
      "title": "Сопоставление атрибутов",
      "description": "Настройка правил извлечения значений атрибутов пользователя из ответа OIDC-провайдера",
      "addButton": "Добавить",
      "table": {
        "name": "Название",
        "expression": "Выражение",
        "syncType": "Тип синхронизации",
        "actions": "Действия"
      },
      "syncType": {
        "DISABLE": "Синхронизация выключена",
        "PERIODIC": "Обновлять периодически",
        "ON_CREATE": "Только при создании пользователя",
        "IF_EXIST": "Обновлять только если значение пришло от IdP"
      },
      "hasRule": "Правило настроено",
      "editRule": "Редактировать правило",
      "deleteConfirm": {
        "title": "Удаление атрибута",
        "message": "Вы уверены, что хотите удалить атрибут \"{{attribute}}\"?"
      },
      "addModal": {
        "title": "Добавить атрибут",
        "searchPlaceholder": "Поиск атрибутов...",
        "selectAll": "Выбрать все",
        "noAttributes": "Нет доступных атрибутов",
        "apply": "Применить"
      },
      "editModal": {
        "title": "Редактирование правила для атрибута: {{attribute}}",
        "description": "Введите jq-выражение для извлечения значения из JSON-объекта user_info, получаемого от OIDC-провайдера. Корень . представляет весь объект user_info.",
        "examples": "Примеры:",
        "example1": "Простое поле: .email",
        "example2": "Вложенное поле: .profile.first_name",
        "example3": "Конкатенация: .given_name + \" \" + .family_name",
        "example4": "Значение по умолчанию: .nickname // .preferred_username",
        "syncTypeLabel": "Тип синхронизации",
        "syncTypeDescription": "Выберите способ синхронизации атрибута из IdP"
      }
    },
    "test": {
      "button": "Протестировать соединение",
      "title": "Результаты тестирования OIDC подключения",
      "loading": "Загрузка результатов тестирования...",
      "error": "Ошибка",
      "noKey": "Отсутствует ключ для получения результатов теста. Пожалуйста, повторите тестирование заново.",
      "unknownError": "Неизвестная ошибка",
      "unknownProvider": "Неизвестный провайдер",
      "successTitle": "Тест пройден успешно",
      "failureTitle": "Тест завершился с ошибкой",
      "successMessage": "Аутентификация через провайдер {{provider}} прошла успешно. Маппинг полей выполнен корректно.",
      "errorDetails": "Детали ошибки",
      "mappedUser": "Смапленные данные пользователя",
      "rawData": "Сырые данные от OIDC провайдера",
      "fullResult": "Полный результат",
      "closeWindowHint": "Вы можете безопасно закрыть это окно.",
      "saveFirst": "Сначала необходимо сохранить настройки провайдера, прежде чем тестировать соединение.",
      "backToSettings": "Вернуться к настройкам",
      "closeWindow": "Закрыть окно",
      "popupBlocked": "Всплывающее окно заблокировано",
      "popupBlockedMessage": "Разрешите всплывающие окна для этого сайта или тестирование будет выполнено в текущем окне",
      "testingProvider": "Тестирование провайдера {{provider}}...",
      "connectionFailed": "Ошибка подключения к OIDC провайдеру",
      "errorStatus": "Статус: {{status}}",
      "providerName": "Провайдер",
      "errorType": "Тип ошибки"
    }
  },
  "monitoringPage": {
    "exporters": "Экспортеры",
    "exporter": "Экспортер",
    "exportersList": {
      "title": "Список экспортеров",
      "empty": "Список экспортеров пуст",
      "newElement": "Новый экспортер"
    },
    "modules": "Модули",
    "module": "Модуль",
    "withoutModule": "Без модуля",
    "jobs": "Задания",
    "job": "Задание",
    "editManually": "Редактировать вручную",
    "incorrectFormat": "Некорректный формат",
    "incorrectNameFormat": "Имя должно начинаться со строчной латинской буквы и может содержать только строчные буквы, цифры и символ подчеркивания.",
    "endpointForReload": "Endpoint для перезагрузки конфигурации экспортера",
    "redisKey": "Redis ключ",
    "copyToClipboard": "Скопировать в буффер обмена",
    "copyEnabled": "Подключение к сайту не защищено, ключ не может быть скопирован в буфер обмена",
    "copiedSuccessfully": "Успешно скопированно",
    "list": {
      "title": "Список шаблонов",
      "empty": "Список шаблонов пуст",
      "newElement": "Новый шаблон"
    },
    "exportersModal": {
      "control_mode": "Источник конфигурации",
      "mode": {
        "no_control": "Локальная",
        "redis": "Redis",
        "container": "Docker-контейнер"
      },
      "test_connection": "Проверить",
      "docker_url": "Адрес Docker",
      "container": "Контейнер",
      "success": "Успешно",
      "errror": "Ошибка",
      "endpoint": "HTTP endpoint",
      "config_path": "Путь к файлу конфигурации",
      "show_logs": "Логи контейнера",
      "apply_success": "Конфигурация применена",
      "connection_success": "Подключено",
      "connection_error": "Не удалось подключиться",
      "container_not_in_list": "Контейнера нет в списке",
      "command": "Команда",
      "update_method": {
        "endpoint": "Reload через HTTP",
        "command": "Команда в контейнере",
        "restart": "Перезапуск контейнера"
      },
      "tabs": {
        "exporter": "Экспортер",
        "source": "Настройка источника конфигурации"
      },
      "source": {
        "localTitle": "Источник: Локальная",
        "localDescription": "Конфигурация сохраняется только в текущем интерфейсе управления. Перенос и применение файла на стороне самого экспортера выполняется пользователем самостоятельно.",
        "redisTitle": "Источник: Redis",
        "redisKey": "Ключ Redis",
        "redisKeyDescription": "По этому ключу конфигурация будет храниться в Redis",
        "containerTitle": "Источник: Docker-контейнер",
        "connectionSection": "Подключение",
        "fileSection": "Целевой файл",
        "updateSection": "Способ применения изменений",
        "endpointHint": "После записи конфигурации будет выполнен HTTP-запрос для применения изменений.",
        "commandHint": "Команда будет выполнена в контейнере после записи конфигурации.",
        "restartHint": "После записи конфигурации контейнер будет перезапущен."
      },
      "actions": {
        "saveAndApply": "Сохранить и применить",
        "apply": "Применить"
      },
      "compare": {
        "containerTitle": "Конфигурация из контейнера",
        "redisTitle": "Конфигурация из Redis",
        "containerDescription": "Ниже показана конфигурация, прочитанная из контейнера. Вы можете сохранить ее как текущую.",
        "redisDescription": "Ниже показана конфигурация, прочитанная из Redis. Вы можете сохранить ее как текущую.",
        "sourcePath": "Источник",
        "container": "Контейнер",
        "current": "Текущая конфигурация",
        "fromContainer": "Конфигурация из контейнера",
        "fromRedis": "Конфигурация из Redis",
        "applyContainer": "Сохранить конфигурацию из контейнера как текущую",
        "applyRedis": "Сохранить конфигурацию из Redis как текущую"
      }
    },
    "areas": {
      "name": "Системное имя",
      "nameDescription": "Используется внутри системы",
      "label": "Название",
      "depends": "Зависимости",
      "template": "Шаблон",
      "key": "Ключ",
      "config": "Конфигурация"
    },
    "editWarningTitle": "Изменено название задания",
    "editWarningText": "В связанных метриках существующих шаблонов монитринга задание будет отображаться по новому имени"
  },
  "pagesSettingsPage": {
    "list": {
      "title": "Конфигурации",
      "empty": "Список конфигураций пуст"
    },
    "item": {
      "empty": "Выберите конфигурацию или создайте новую"
    }
  },
  "pagesSettingsItem": {
    "title": "Страница",
    "config": {
      "name": "Название",
      "nameResolution": "Название разрешения",
      "keyPath": "Ключ пути",
      "width": "Ширина экрана",
      "height": "Высота экрана",
      "fixedHeight": "Фиксированная высота",
      "layout": "Макет",
      "preview": "Предпросмотр"
    }
  },
  "mainPageLayout": {
    "device-status": "Статус устройств",
    "alarms": "Тревоги",
    "attacks": "Атаки",
    "device-utilization": "Устройства утилизации",
    "fake-1": "fake-1",
    "fake-2": "fake-2"
  },
  "pageWidgetConfigDialog": {
    "title": "Настройка виджета",
    "height": "Высота (%)"
  },
  "enrichmentSettingsPage": {
    "list": {
      "title": "Планы обогащения",
      "empty": "Список планов пуст",
      "group": "Группа",
      "plan": "План"
    },
    "modal": {
      "firstStep": {
        "label": "Загрузка",
        "description": "Прикрепите JSON файл"
      },
      "secondStep": {
        "label": "Анализ",
        "description": "Подтвердите действия",
        "title": "Результаты анализа конфигурации"
      },
      "thirdStep": {
        "label": "Результат",
        "description": "Мониторинг прогресса",
        "title": "Импорт завершен",
        "errorTitle": "Импорт отменен"
      }
    },
    "item": {
      "empty": "Выберите элемент или создайте новый",
      "group": "Группа",
      "plan": "План обогащения СРМ",
      "name": "Название",
      "label": "Отображение",
      "parent": "Родительская группа",
      "cron": {
        "name": "Периодичность запуска",
        "description": "Периодичность запуска задается в виде CRON выражения. Строка состоит из 5 ячеек, разделяемых пробелами. Ячейки задают время выполнения (минута, час, день, месяц, день недели), в них может находиться число, список чисел, разделённых запятыми, диапазон чисел, разделённых дефисом, символы “*” или “/”.",
        "code": "* * * * * выполняемая команда\n- - - - -\n| | | | |\n| | | | ----- месяц (1—12)\n| | | ------- день (1—31)\n| | --------- день недели (0-6)\n| ----------- час (0—23)\n------------- минута (0—59)",
        "errorMsg": "Некорректное выражение"
      },
      "active": "Активно",
      "filter": "Фильтр"
    }
  },
  "actionPlansSettingsPage": {
    "list": {
      "title": "Планы действий",
      "empty": "Список планов пуст",
      "group": "Группа",
      "plan": "План"
    },
    "item": {
      "empty": "Выберите элемент или создайте новый",
      "group": "Группа",
      "plan": "План действий",
      "name": "Название",
      "type": "Тип",
      "multiply": "Множественное",
      "parent": "Родительская группа",
      "cron": {
        "name": "Периодичность запуска",
        "description": "Периодичность запуска задается в виде CRON выражения. Строка состоит из 5 ячеек, разделяемых пробелами. Ячейки задают время выполнения (минута, час, день, месяц, день недели), в них может находиться число, список чисел, разделённых запятыми, диапазон чисел, разделённых дефисом, символы “*” или “/”.",
        "code": "* * * * * выполняемая команда\n- - - - -\n| | | | |\n| | | | ----- месяц (1—12)\n| | | ------- день (1—31)\n| | --------- день недели (0-6)\n| ----------- час (0—23)\n------------- минута (0—59)",
        "errorMsg": "Некорректное выражение"
      },
      "active": "Активно",
      "filter": "Фильтр",
      "actions": "Действия",
      "vars": "Переменные",
      "var": "Переменная",
      "saveToVars": "Записать результат выполнения в переменные",
      "saveFilterResultToVars": "Записать результат фильтра в переменные",
      "multipleCi": "Возвращать список",
      "value": "Значение",
      "attribute": "Шаблон",
      "types": {
        "search": "Поиск",
        "ci_add": "Добавить CI"
      }
    }
  },
  "globalSettingsPage": {
    "title": "Глобальные настройки",
    "services": {
      "auth": "Авторизация",
      "srm": "СРМ",
      "monitoring": "Мониторинг",
      "notification": "Уведомления",
      "docker_tool": "Docker tool",
      "task_tool": "Task tool"
    },
    "columns": {
      "name": "Имя",
      "valueType": "Тип данных",
      "description": "Описание",
      "value": "Значение",
      "actions": "Действия",
      "status": "Статус",
      "tqlEdge": "Узел TQL"
    }
  },
  "schedulesPage": {
    "title": "Периодические задания",
    "services": {
      "srm": "СРМ",
      "monitoring": "Мониторинг"
    },
    "columns": {
      "task": "Задача",
      "systemName": "Системное имя",
      "schedule": "Периодичность"
    },
    "dialog": {
      "cron": {
        "name": "Периодичность запуска",
        "description": "Периодичность запуска задаётся выражением cron из пяти полей, разделённых пробелами: минута, час, день месяца, месяц, день недели. В поле может находиться число, список чисел через запятую, диапазон через дефис, а также символы «*» и «/».",
        "code": "* * * * * выполняемая задача\n- - - - -\n| | | | |\n| | | | ----- день недели (0—6, 0 — воскресенье)\n| | | ------- месяц (1—12)\n| | --------- день месяца (1—31)\n| ----------- час (0—23)\n------------- минута (0—59)",
        "errorMsg": "Некорректное выражение"
      },
      "reset": "По умолчанию",
      "resetHint": "Для этой задачи значение по умолчанию не задано"
    },
    "tasks": {
      "srm": {
        "send_outbox_events": "Отправка накопленных событий СРМ в брокер сообщений",
        "check_tqls": "Проверка и актуализация сохранённых TQL-запросов",
        "clean_orphan_files": "Удаление файлов, на которые не осталось ссылок",
        "clean_users": "Удаление объектов, связанных с удалёнными пользователями",
        "clean_expires_cookies": "Удаление просроченных cookie из хранилища фетчеров",
        "delete_old_statistics": "Удаление устаревших записей статистики обогащения",
        "delete_marked_cis": "Физическое удаление КЕ, помеченных к удалению",
        "clean_bulk_import_jobs": "Удаление устаревших заданий массового импорта КЕ"
      },
      "monitoring": {
        "send_outbox_events": "Отправка накопленных событий мониторинга в брокер сообщений",
        "hi_outbox": "Обработка очереди пересчёта индикаторов здоровья",
        "alert_repair": "Закрытие алертов с истёкшим сроком действия",
        "history_cleanup": "Удаление истории индикаторов здоровья и алертов старше заданного срока",
        "keep_alive_template_tql": "Поддержание актуальности TQL-запросов шаблонов мониторинга",
        "check_hi_history": "Проверка консистентности индикаторов здоровья и их истории"
      }
    }
  },
  "systemSettingsPage": {
    "name": "Название",
    "empty": "Выберите демон или создайте новый",
    "tableTitle": "Компоненты",
    "title": "Список docker демонов",
    "itemTitle": "Докер демон",
    "newElement": "Новый демон",
    "tabs": {
      "daemon": "Настройки подключения",
      "components": "Docker контейнеры"
    },
    "daemon": {
      "url_created": "URL создан",
      "url_changed": "URL изменен",
      "connection_established": "Подключение установлено",
      "connection_failed": "Не удалось установить подключение"
    },
    "columns": {
      "name": "Название контейнера",
      "container_id": "ID контейнера",
      "image": "Docker image",
      "status": "Статус",
      "created": "Создан"
    }
  },
  "notificationsSettingsPage": {
    "time_interval": {
      "empty": "Выберите интервал или создайте новый",
      "title": "Список интервалов времени",
      "itemTitle": "Интервал времени",
      "newElement": "Новый интервал времени",
      "nameField": "Название интервала времени"
    },
    "senders": {
      "empty": "Выберите отправитель или создайте новый",
      "title": "Список отправителей",
      "itemTitle": "Отправитель",
      "newElement": "Новый отправитель",
      "nameField": "Название отправителя",
      "type": "Тип отправителя",
      "active": "Активный"
    }
  },
  "attributesCompletion": {
    "attributes": "Атрибуты",
    "target_attributes": "Атрибуты назначения",
    "link_attributes": "Атрибуты связи",
    "fields": "Поля метрик"
  },
  "vmagentsPage": {
    "listEmpty": "Список агентов пуст",
    "listTitle": "Список агентов",
    "formFields": {
      "name": "Системное имя",
      "label": "Отображение",
      "enabled": "Включить пересборку конфигурации",
      "validationType": "Тип валидации",
      "jobs": "Задания",
      "tags": "Теги",
      "config": "Конфигурация",
      "apiBaseUrl": "Базовый адрес API",
      "apiBaseUrlHint": "Адрес monitoring, доступный из сети этого экземпляра, в формате http(s)://<хост>[:<порт>][/<путь>]. Если не задан, используется общий адрес системы."
    },
    "notification": {
      "title": "Список заданий сброшен",
      "content": "При изменении типа валидации список выбранных заданий очищается. Пожалуйста, выберите задания заново."
    }
  },
  "vmalertsPage": {
    "listEmpty": "Список агентов пуст",
    "listTitle": "Список агентов",
    "openTab": "Открыть в новой вкладке",
    "formFields": {
      "name": "Системное имя",
      "label": "Отображение",
      "tags": "Теги",
      "config": "Конфигурация",
      "managed": "Управление",
      "url": "URI для получения конфигурации",
      "alertUrl": "URL для обработки алертов",
      "deduplicationGroupBy": "Группировка по лейблам",
      "deduplicationGroupByHint": "Лейблы, по которым будет производиться группировка алертов.",
      "deduplicationIgnore": "Игнорируемые лейблы",
      "deduplicationIgnoreHint": "Лейблы, которые будут вырезаны из алертов перед обработкой.",
      "deduplicationPlaceholder": "Введите лейбл и нажмите Enter",
      "apiBaseUrl": "Базовый адрес API",
      "apiBaseUrlHint": "Адрес monitoring, доступный из сети этого экземпляра, в формате http(s)://<хост>[:<порт>][/<путь>]. Если не задан, используется общий адрес системы."
    }
  },
  "s3Page": {
    "listEmpty": "Список S3-коннекторов пуст",
    "listTitle": "S3-коннекторы",
    "newItem": "Новый S3-коннектор",
    "actions": {
      "checkConnection": "Проверить подключение"
    },
    "formFields": {
      "label": "Название",
      "endpoint": "Endpoint",
      "bucket": "Бакет",
      "region": "Регион",
      "prefix": "Prefix",
      "credentials": "Учётные данные",
      "accessKey": "Логин",
      "secretKey": "Пароль",
      "secretKeyPlaceholder": "Не менять",
      "verifySsl": "Проверять сертификат",
      "pathStyle": "Path-style: /bucket/key"
    },
    "test": {
      "successTitle": "Проверка подключения успешна",
      "successMessage": "Подключение установлено",
      "successMessageWithStatus": "Подключение установлено. HTTP-статус: {{status}}",
      "failureTitle": "Проверка подключения не удалась",
      "failureMessage": "S3 вернул HTTP-статус: {{status}}"
    }
  },
  "jobsPage": {
    "linkedVMAgents": "Количество связанных vmagent",
    "listEmpty": "Список заданий пуст",
    "dialog": {
      "header": {
        "403": "Ошибка доступа",
        "405": "Задание используют активные метрики шаблонов мониторинга",
        "409": "Подтвердите удаление задания",
        "info": "Вместе с заданием будут удалены все </br>связанные <strong>ВЫКЛЮЧЕННЫЕ</strong> метрики. Продолжить?"
      },
      "notification": {
        "403": "У вас нет прав для этого действия",
        "405": "Отключите метрики для удаления задания",
        "409": "Удаление задания приведет к удалению метрик в шаблонах мониторинга"
      },
      "metricName": "Название метки",
      "job": "Задание",
      "status": "Статус",
      "disable": "Выключить",
      "monitoringTemplateName": "Название шаблона мониторинга",
      "continue": "Продолжить",
      "delete": "Удалить"
    },
    "formFields": {
      "name": "Имя",
      "label": "Отображение",
      "validationType": "Тип валидации",
      "agents": "Агенты сбора метрик",
      "tags": "Теги",
      "template": "Конфигурация",
      "notification": {
        "title": "Список агентов сбора метрик сброшен",
        "content": "При изменении типа валидации список выбранных агентов сбора метрик очищается. Пожалуйста, выберите их заново."
      }
    }
  },
  "pluginsPage": {
    "tabs": {
      "downloaded": "Загруженные",
      "installed": "Установленные"
    },
    "columns": {
      "name": "Название",
      "nameOfArchive": "Название архива плагина",
      "size": "Размер",
      "version": "Версия",
      "time": "Время создания",
      "actions": "Действия",
      "displayName": "Отображаемое имя",
      "contentType": "Тип содержимого"
    },
    "tooltips": {
      "install": "Установить",
      "installOnRunner": "Установить на пробу",
      "download": "Загрузить",
      "deletePlugin": "Удалить",
      "deinstallWarning": "Вы уверены, что хотите дейсталлировать плагин?"
    },
    "installModal": {
      "alreadyExists": "Выбранный плагин уже установлен.",
      "reinstallPlugin": "Обновить установленный плагин?"
    }
  },
  "enrichment-statistics": {
    "title": "Статистика обогащения"
  },
  "monitoringTemplateTabs": {
    "scopeOfApplication": "Область применения",
    "metrics": "Метрики",
    "hi": "Индикаторы здоровья"
  },
  "notifications": {
    "alertManagerTitle": "Alert Manager",
    "inhibitRulesTitle": "Правила подавления",
    "templatesTitle": "Шаблоны",
    "notificationsGeneralTitle": "Общие настройки"
  },
  "deletePolicyTab": {
    "mode": "Что делать с КЕ, помеченными к удалению",
    "modePeriod": "Удалять по сроку",
    "modeForever": "Хранить бессрочно",
    "keepDays": "Хранить после пометки к удалению",
    "days": "суток",
    "zeroHint": "КЕ удалится при ближайшем запуске задачи, восстановление при обогащении фактически отключено",
    "restoreTitle": "Удалённую КЕ можно вернуть",
    "restoreHint": "Пока срок не истёк, обогащение может найти КЕ снова - она восстановится вместе с идентификатором, историей и связями. После физического удаления восстановление невозможно.",
    "compositionTitle": "Владелец композиции сильнее этого срока",
    "compositionHint": "КЕ этого типа входят в композицию: {{ciTypes}}. Когда физически удаляется композирующая КЕ, все её составные части удаляются вместе с ней - независимо от срока и режима, заданных здесь. Срок применяется только к КЕ, удалённым отдельно от владельца.",
    "waitingOwn": "Ждут удаления, свой тип",
    "waitingChildren": "Ждут удаления, дочерние ТКЕ",
    "deleteNow": "Удалить сейчас",
    "deleted": "Удалено КЕ: {{count}}",
    "deleteDialog": {
      "title": "Удалить помеченные КЕ",
      "description": "Будут физически удалены все КЕ этого ТКЕ, у которых проставлена дата удаления, - не дожидаясь окончания срока хранения.",
      "withChildren": "Удалить КЕ в дочерних ТКЕ",
      "warningTitle": "Действие необратимо",
      "warning": "Будет удалено КЕ: {{count}}, а также всё, что входит в них по композиции."
    },
    "aliveOwn": "Действующие КЕ, свой тип",
    "aliveChildren": "Действующие КЕ, дочерние ТКЕ",
    "deleteSection": "Удаление КЕ",
    "deleteSectionHint": "Сначала КЕ помечаются к удалению, потом удаляются физически - по сроку хранения или кнопкой «Удалить сейчас».",
    "markAll": "Пометить все к удалению",
    "marked": "Помечено к удалению КЕ: {{count}}",
    "markAllDialog": {
      "title": "Пометить все КЕ к удалению",
      "description": "Все действующие КЕ ТКЕ «{{ciType}}» будут помечены к удалению вместе с составными частями. Уже помеченные КЕ не меняются - их срок хранения не начинается заново.",
      "withChildren": "Пометить КЕ в дочерних ТКЕ",
      "withChildrenHint": "{{types}} ТКЕ · {{count}} КЕ",
      "columnCiType": "ТКЕ",
      "columnCiCount": "КЕ",
      "groupOwn": "Свой ТКЕ",
      "groupChildren": "Дочерние ТКЕ",
      "groupComposed": "Составные части - помечаются вместе с владельцем",
      "alreadyMarked_one": "ещё {{count}} уже помечена к удалению - не меняется",
      "alreadyMarked_few": "ещё {{count}} уже помечены к удалению - не меняются",
      "alreadyMarked_many": "ещё {{count}} уже помечены к удалению - не меняются",
      "noOwnCis": "Своих действующих КЕ нет - чтобы пометить КЕ дочерних ТКЕ, отметьте флажок выше",
      "via": "через «{{ciType}}»",
      "total": "Итого будет помечено",
      "timingTitle": "Физически КЕ удалятся позже",
      "timingForeverTitle": "ТКЕ хранит помеченные КЕ бессрочно",
      "timingPeriod_one": "Через {{count}} сутки по сроку хранения ТКЕ «{{ciType}}» или сразу кнопкой «Удалить сейчас».",
      "timingPeriod_few": "Через {{count}} суток по сроку хранения ТКЕ «{{ciType}}» или сразу кнопкой «Удалить сейчас».",
      "timingPeriod_many": "Через {{count}} суток по сроку хранения ТКЕ «{{ciType}}» или сразу кнопкой «Удалить сейчас».",
      "timingZero": "При ближайшем запуске задачи удаления или сразу кнопкой «Удалить сейчас».",
      "timingForever": "Физически удалить их можно только кнопкой «Удалить сейчас».",
      "timingChildren": "У дочерних ТКЕ - свои сроки.",
      "timingComposed": "Составные части удалятся вместе с владельцем.",
      "timingRestore": "Пока КЕ не удалены, обогащение может найти их снова и вернуть вместе с идентификатором, историей и связями; кнопки восстановления нет.",
      "confirmLabel": "Для подтверждения введите системное имя ТКЕ: {{ciType}}",
      "confirmError": "Не совпадает с системным именем ТКЕ",
      "submit": "Пометить к удалению",
      "notWritableTitle": "Нет прав на часть КЕ",
      "notWritable": "Правила доступа к СРМ не разрешают вам менять КЕ: {{count}}. Пометить все КЕ можно, только когда право на изменение есть для каждой из них."
    }
  },
  "adminNotifications": {
    "columns": {
      "owner": "Владелец",
      "state": "Состояние"
    },
    "filters": {
      "searchSubscription": "Название или системное имя",
      "searchReceiver": "Название адресата",
      "sender": "Отправитель",
      "problemsOnly": "Только проблемные"
    },
    "senderTypes": {
      "EMAIL": "Почта",
      "TELEGRAM": "Telegram",
      "WEBHOOK": "Webhook"
    },
    "subscriptions": {
      "title": "Подписки на индикаторы здоровья",
      "columns": {
        "label": "Название",
        "hi": "Индикатор здоровья",
        "severities": "Критичность",
        "receiver": "Адресат",
        "delivery": "Доставка"
      },
      "receiverDeleted": "адресат удалён",
      "hiUnavailable": "привязка недоступна",
      "bell": "В браузере",
      "undelivered": "Не доставляется",
      "undeliveredNoReceiver": "адресат не задан, браузер выключен",
      "undeliveredNoChannel": "у адресата нет активных каналов",
      "deleteTitle": "Удалить подписку? Уведомления по ней перестанут приходить владельцу.",
      "actions": {
        "card": "Карточка подписки",
        "goToTemplate": "Перейти к ИЗ в шаблоне"
      },
      "card": {
        "title": "Подписка «{{label}}»",
        "systemName": "Системное имя",
        "template": "Шаблон мониторинга",
        "node": "Узел TQL",
        "bell": "Уведомления в браузере",
        "groupBy": "Группировать уведомления",
        "groupWait": "Интервал создания группы",
        "groupInterval": "Интервал расширения группы",
        "repeatInterval": "Интервал напоминания",
        "extendMatchers": "Расширенный фильтр событий"
      },
      "enableConfirm": {
        "title_one": "Включить {{count}} подписку",
        "title_few": "Включить {{count}} подписки",
        "title_many": "Включить {{count}} подписок",
        "title_other": "Включить {{count}} подписок",
        "warning_one": "{{count}} подписка не начнёт доставляться",
        "warning_few": "{{count}} подписки не начнут доставляться",
        "warning_many": "{{count}} подписок не начнут доставляться",
        "warning_other": "{{count}} подписок не начнут доставляться",
        "description": "У них не задан адресат и выключены уведомления в браузере — маршрут не попадёт в конфигурацию Alertmanager.",
        "replayHint": "После включения сервис повторит текущие состояния индикаторов для владельцев подписок."
      },
      "deleteManyTitle_one": "Удалить {{count}} подписку? Уведомления по ней перестанут приходить владельцу.",
      "deleteManyTitle_few": "Удалить {{count}} подписки? Уведомления по ним перестанут приходить владельцам.",
      "deleteManyTitle_many": "Удалить {{count}} подписок? Уведомления по ним перестанут приходить владельцам.",
      "deleteManyTitle_other": "Удалить {{count}} подписок? Уведомления по ним перестанут приходить владельцам."
    },
    "receivers": {
      "title": "Адресаты пользователей",
      "columns": {
        "channels": "Каналы отправки",
        "subscriptions": "Подписок"
      },
      "noChannels": "каналы не заданы",
      "senderDisabled": "отправитель отключён",
      "active": "Активен",
      "noActiveChannels": "Нет активных каналов",
      "deleteTitle": "Удалить адресата?",
      "forceDelete": {
        "modalTitle": "Удаление адресата «{{name}}»",
        "title": "Адресат используется активными подписками",
        "description": "Удалите или переключите эти подписки, либо подтвердите принудительное удаление — подписки останутся без адресата и перестанут доставлять уведомления.",
        "submit": "Удалить принудительно"
      }
    }
  }
}